<template>
    <div style="height: 100%">
        <PesquisaList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import PesquisaList from '@/components/promotor/relatorio-analitico/relatorio-pesquisa/RelatorioPesquisaList.vue';

export default {
    name: 'RelatorioPesquisaListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'relatorio-pro-pesquisa-list';
        if (
            from.name != 'relatorio-pro-pesquisa-list' &&
            to.name == 'relatorio-pro-pesquisa-list'
        ) {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        PesquisaList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('relatorio-pro-pesquisa') &&
            this.$route.name != 'relatorio-pro-pesquisa-list';
    },
};
</script>
